import React from 'react';
import { css } from 'twin.macro';
import { VscLoading } from 'react-icons/vsc';
import PlaceCard from '../../RealEstate/PlaceCard';
import PlaceDetail from '../../RealEstate/PlaceDetail';

function PlacesListOverlay({
    showPlaces,
    showRealEstate,
    selectedPlace,
    onClose,
    onBack,
    placesLoading,
    placesResults,
    onSelectPlace,
    onAddToCalendar,
}) {
    if (!showPlaces || showRealEstate) return null;

    return (
        <>
            {/* Places: list overlay when enabled and RE is not active */}
            <div
                css={css`
                    position: absolute;
                    top: 60px;
                    right: 56px;
                    background-color: #ffffff;
                    width: 420px;
                    padding: 0;
                    overflow-y: auto;
                    border-radius: 6px;
                    box-shadow: 0px 15px 35px rgba(0, 0, 0, 0.6);
                    max-height: 80vh;
                `}
            >
                {/* Header */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px 14px 8px',
                        borderBottom: '1px solid #eee',
                        position: 'sticky',
                        top: 0,
                        background: '#fff',
                        zIndex: 1,
                    }}
                >
                    {selectedPlace ? (
                        <div style={{ fontWeight: 700, fontSize: 15 }}>{selectedPlace.name || 'Place'}</div>
                    ) : (
                        <h2 className="text-dark mb-0" style={{ fontSize: 18, fontWeight: 700 }}>
                            Places {placesResults.length > 0 && `(${placesResults.length})`}
                        </h2>
                    )}
                    <span onClick={onClose} style={{ cursor: 'pointer', fontSize: 18, color: '#999' }}>
                        X
                    </span>
                </div>

                {/* Body: detail or list */}
                {selectedPlace ? (
                    <PlaceDetail item={selectedPlace} onBack={onBack} onAddToCalendar={onAddToCalendar} />
                ) : placesLoading ? (
                    <div style={{ padding: 20, textAlign: 'center', color: '#777' }}>
                        <VscLoading className="spin mr-2" /> Searching places...
                    </div>
                ) : placesResults.length > 0 ? (
                    placesResults.map((item) => (
                        <PlaceCard
                            key={item.id}
                            item={item}
                            selected={selectedPlace?.id === item.id}
                            onClick={() => onSelectPlace(item)}
                        />
                    ))
                ) : (
                    <div style={{ padding: 20, color: '#777', textAlign: 'center' }}>
                        No places found. Try a different search.
                    </div>
                )}
            </div>
        </>
    );
}

export default PlacesListOverlay;
